import React from 'react';
import { Link } from 'react-router-dom';

const GuidePage = () => {
  return (
    <div className="page-wrapper">
      <div className="page-hero">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/">Anasayfa</Link>
            <span>/</span>
            <span>Şerit Testere Seçimi Rehberi</span>
          </div>
          <h1>Hangi Testere Hangi Malzeme İçin Kullanılmalı?</h1>
          <p>Malzemenize en uygun testereyi seçerek kesim maliyetlerinizi düşürün ve makine ömrünü uzatın.</p>
        </div>
      </div>

      <div className="container page-layout">
        <main className="page-content" style={{ padding: '4rem 0', maxWidth: '800px', margin: '0 auto' }}>
          <div className="seo-content">
            <p>
              Endüstriyel metal ve alaşım kesim işlemlerinde maliyetleri düşürmenin ve verimliliği artırmanın en kritik adımı, keseceğiniz malzemenin fiziksel ve kimyasal yapısına en uygun <strong>şerit testere bıçağını</strong> seçmektir. Doğru şerit testere seçimi yapılmadığında makinenizin ömrü kısalır, kesim süreleri uzar ve en kötüsü, testere dişlerinde erken kırılmalar meydana gelir.
            </p>
            
            <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>Standart ve Yapı Çelikleri</h2>
            <p>
              Atölyenizde çoğunlukla karbon çeliği, ıslah çelikleri, genel yapı çelikleri ve masif dolu malzemeler (kütükler) kesiyorsanız, yüksek esneklik ve uzun ömür sunan <Link to="/urunler/bimetal" className="text-link">Bimetal Şerit Testereler (M42 ve M51)</Link> en doğru yatırım olacaktır. Bimetal testereler, aşınmaya dirençli diş yapısı ve titreşimi emen sırt tasarımı sayesinde standart çelik kesiminde olağanüstü bir maliyet-performans oranı sunar.
            </p>
            
            <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>Sert ve Isıya Dayanıklı Alaşımlar</h2>
            <p>
              Ancak üretim hattınızda paslanmaz çelik, Inconel, titanyum, takım çelikleri veya yüksek nikel içeren ısıya dayanıklı süper alaşımlar bulunuyorsa, bimetal bıçaklar yetersiz kalacaktır. Bu tür işlenmesi zorlu malzemelerde oluşan yüksek termal ısıyı ve mekanik direnci yenebilmek için <Link to="/urunler/karbur" className="text-link">Karbür Uçlu (TCT) Şerit Testereler</Link> tercih edilmelidir. Karbür (elmas uçlu) testereler, yüksek devir ve ilerleme hızlarında dahi keskinliğini koruyarak kesim sürelerinizi ciddi oranda kısaltır.
            </p>
            
            <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>Aşırı Sert ve Kırılgan Malzemeler</h2>
            <p>
              Bununla birlikte, geleneksel şerit testere bıçaklarının kesemediği cam, seramik, grafit, karbon fiber kompozitler veya 55 HRC ve üzeri sertleştirilmiş çeliklerde ise ileri teknoloji ürünü <Link to="/urunler/elmas-cbn" className="text-link">Elmas (Diagrit) ve CBN (Cubogrit) kaplı testereler</Link> devreye girer. Bu testereler çapaksız ve sıfır fire ile mükemmel pürüzsüzlükte kesim yapmanıza olanak tanır.
            </p>
            
            <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>Alüminyum, Ahşap ve Hafif Metaller</h2>
            <p>
              Ayrıca demir dışı hafif metaller, alüminyum alaşımları, ahşap veya plastik gibi daha yumuşak ancak yapışkan özellik gösterebilen malzemeler için <Link to="/urunler/karbon" className="text-link">Karbon Şerit Testereler</Link> hem esnek hem de son derece ekonomik bir çözüm sunmaktadır.
            </p>

            <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>Doğru Diş Adımı (TPI) Seçimi</h2>
            <p>
              Mükemmel kesim performansı sadece malzemenin cinsine değil, aynı zamanda <strong>diş adımı (TPI - Teeth Per Inch)</strong>, diş geometrisi ve bant kalınlığına da bağlıdır. İnce cidarlı profiller veya borular kesiyorsanız, titreşimi (vibrasyonu) en aza indirmek için mutlaka değişken adımlı (VA - Variable Pitch) testereler kullanılmalıdır. Dolu kütüklerde ise talaş tahliyesinin kolay olması için daha iri dişli formlar seçilmelidir.
            </p>

            <div style={{ marginTop: '3rem', padding: '2rem', background: '#f8fafc', borderLeft: '4px solid var(--primary)', borderRadius: '8px' }}>
              <h3 style={{ marginBottom: '1rem' }}>Teknik Destek Alın</h3>
              <p style={{ marginBottom: '1rem' }}>
                NetTest Testere olarak, prosesinize en uygun bıçağı belirlemeniz için uzman mühendis kadromuzla her zaman teknik danışmanlık vermeye hazırız.
              </p>
              <a href="https://wa.me/905470013478" target="_blank" rel="noopener noreferrer" className="btn-primary">
                <i className="fa-brands fa-whatsapp" style={{ marginRight: '8px' }}></i> Uzmanla Görüş
              </a>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default GuidePage;
